import { render } from "./projectParts.vue?vue&type=template&id=674f9347&scoped=true&ts=true"
import script from "./projectParts.vue?vue&type=script&lang=ts"
export * from "./projectParts.vue?vue&type=script&lang=ts"

import "./projectParts.vue?vue&type=style&index=0&id=674f9347&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674f9347"]])

export default __exports__